import _ from 'lodash';

export default function ImagePlugin({ decorator = _.identity, Image }) {
  const DecoratedImage = decorator(Image);
  return {
    blockRendererFn: (block, { getEditorState }) => {
      if (block.getType() === 'atomic') {
        const contentState = getEditorState().getCurrentContent();
        const entityKey = block.getEntityAt(0);
        if (entityKey && contentState.getEntity(entityKey).getType() === 'IMAGE') {
          return {
            component: DecoratedImage,
            editable: false,
          };
        }
      }
    },
  };
}



// WEBPACK FOOTER //
// ./app/components/text-editor/plugins/image.js